import { render } from "./CafeMenu.vue?vue&type=template&id=7ddc5480&scoped=true"
import script from "./CafeMenu.vue?vue&type=script&lang=js"
export * from "./CafeMenu.vue?vue&type=script&lang=js"

import "./CafeMenu.vue?vue&type=style&index=0&id=7ddc5480&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ddc5480"]])

export default __exports__